import * as yup from 'yup';

import http from '@/utils/http';

export enum Code {
  TaxCode = 'taxCode',
  Eic = 'eic',
  Itn = 'itn',
}

export const endpoints: Record<Code, string> = {
  [Code.TaxCode]: 'tax-code',
  [Code.Eic]: 'eic',
  [Code.Itn]: 'itn',
};

export interface CodeValidationResult {
  isValid: boolean;
  isExists: boolean;
}

export const INVALID_MESSAGE = 'Невірний формат';
export const ALREADY_USED_MESSAGE = 'Вже використовується';

export const validateCodeFn = (
  key: Code,
  isStructurallyValid: (value: string) => boolean,
  excludeId?: string,
) =>
  async function (
    this: yup.TestContext,
    value?: string | null,
  ): Promise<boolean | yup.ValidationError> {
    if (!value || !isStructurallyValid(value)) return true;

    try {
      const params = new URLSearchParams({ [key]: value });
      if (excludeId) params.set('excludeId', excludeId);

      const { data } = await http<CodeValidationResult>({
        url: `/organizations/${endpoints[key]}/validate?${params.toString()}`,
      });

      if (!data.isValid) return this.createError({ message: INVALID_MESSAGE });
      if (data.isExists)
        return this.createError({ message: ALREADY_USED_MESSAGE });
      return true;
    } catch {
      return false;
    }
  };
